
  import {
    defineComponent,
    ref,
    onMounted,
    computed,
    onBeforeUnmount,
  } from 'vue';
  import { useRouter } from 'vue-router';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';
  import HomeServicesAdvancedSearch from '@/components/search/HomeServicesAdvancedSearch.vue';

  export default defineComponent({
    name: 'home-services-listing',
    components: {
      Datatable,
      HomeServicesAdvancedSearch,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('homeServiceList'), [
          translate('assets'),
        ]);
      });

      onBeforeUnmount(() => {
        store.dispatch(Actions.RESET_HOME_SERVICES_STORE);
      });

      await store.dispatch(Actions.GET_HOME_SERVICES);
      const loading = ref(false);
      const tableHeader = ref([
        {
          name: translate('icon'),
          key: 'icon',
        },
        {
          name: translate('titleEn'),
          key: 'titleEn',
        },
        {
          name: translate('titleAr'),
          key: 'titleAr',
        },
        {
          name: translate('version'),
          key: 'version',
        },
        {
          name: translate('sort'),
          key: 'sort',
        },
        {
          name: translate('home'),
          key: 'isHome',
        },
        {
          name: translate('web'),
          key: 'showWeb',
        },
        {
          name: translate('active'),
          key: 'isActive',
        },
        {
          name: translate('actions'),
          key: 'actions',
        },
      ]);
      const toggleStatusHomeService = async (homeService) => {
        const deletedMessage = homeService.isActive
          ? 'confirmInActive'
          : 'confirmActive';
        const result = await Swal.fire({
          title: translate('areYouSureQ'),
          icon: 'warning',
          text: translate(deletedMessage),
          showCancelButton: true,
          buttonsStyling: false,
          confirmButtonText: translate('confirm'),
          cancelButtonText: translate('cancel'),
          customClass: {
            confirmButton: 'btn fw-bold btn-warning',
            cancelButton: 'btn btn-light',
          },
        });

        if (result.value) {
          loading.value = true;
          await store.dispatch(Actions.DELETE_HOME_SERVICE, homeService.id);
          await store.dispatch(Actions.GET_HOME_SERVICES);
          loading.value = false;
          const [errorName] = Object.keys(store.getters.getErrors);
          const error = store.getters.getErrors[errorName];
          if (error) {
            Swal.fire({
              text: translate(error[0]),
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: translate('tryAgainExcl'),
              customClass: {
                confirmButton: 'btn fw-bold btn-light-danger',
              },
            });
          } else {
            const successMsg = homeService.isActive
              ? 'SUCCESSFULLY_INACTIVATED'
              : 'SUCCESSFULLY_ACTIVEATED';
            Swal.fire({
              text: translate(successMsg),
              icon: 'success',
              buttonsStyling: false,
              confirmButtonText: translate('ok'),
              customClass: {
                confirmButton: 'btn btn-light-primary',
              },
            });
          }
        }
      };

      const goTo = (pageName) => {
        router.push({ name: pageName });
      };
      const editHomeService = (id) => {
        router.push({ name: 'home-services-editing', params: { id } });
      };

      const editSeo = async (id) => {
        router.push({
          name: 'seo-configuration',
          params: { entityType: 'services', entityId: id },
        });
        await store.dispatch(Actions.ADD_BODY_CLASSNAME, 'page-loading-over');
      };

      const pageChanged = async (val) => {
        loading.value = true;
        await store.dispatch(Actions.UPDATE_HOME_SERVICE_CURRENT_PAGE, val);
        await store.dispatch(Actions.GET_HOME_SERVICES);
        loading.value = false;
      };

      const onFilterChange = async (filterValues) => {
        loading.value = true;
        await store.dispatch(Actions.UPDATE_HOME_SERVICES_FILTER, {
          description: filterValues.description,
          version: filterValues.version,
        });
        await store.dispatch(Actions.GET_HOME_SERVICES);
        loading.value = false;
      };

      const onResetFilters = async (value) => {
        loading.value = true;
        await store.dispatch(Actions.UPDATE_HOME_SERVICES_FILTER, value);
        await store.dispatch(Actions.GET_HOME_SERVICES);
        loading.value = false;
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');
      return {
        tableData: computed(() => store.getters.homeServicesList),
        totalItems: computed(() => store.getters.homeServicesListCount),
        tableHeader,
        toggleStatusHomeService,
        translate,
        pageChanged,
        goTo,
        editHomeService,
        loading,
        can,
        onFilterChange,
        onResetFilters,
        editSeo,
      };
    },
  });
